import React from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa6';
import { WHATSAPP_URL } from '../constants';

const WhatsAppButton = () => (
  <motion.a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with us on WhatsApp"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1, type: 'spring', stiffness: 260, damping: 18 }}
    className="group fixed bottom-5 right-5 md:bottom-8 md:right-8 z-40 flex items-center gap-2"
    data-testid="whatsapp-chat-btn"
  >
    <span className="bg-white text-ink rounded-2xl rounded-br-sm shadow-lg border border-slate-100 px-3.5 py-2 leading-tight transition-transform duration-300 group-hover:-translate-x-1" data-testid="whatsapp-reply-note">
      <span className="block text-[13px] font-bold">Chat with us</span>
      <span className="flex items-center gap-1.5 text-[11px] text-slate-500">
        <span className="w-1.5 h-1.5 rounded-full bg-[#25D366]" /> We reply within minutes
      </span>
    </span>
    <span className="relative w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_10px_30px_-8px_rgba(37,211,102,0.8)] transition-transform duration-300 group-hover:scale-110">
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      <FaWhatsapp size={30} className="relative" />
    </span>
  </motion.a>
);

export default WhatsAppButton;
